
import { computed, defineComponent, PropType } from 'vue';

import PObj from '@/objects/player';
import { useStore } from '@/store';

import RoleIcon from '@/components/svg/RoleIcon.vue';
import PlayerCard from '@/components/PlayerCard.vue';
import MutationTypes from '@/store/mutation-types';

export default defineComponent({
  name: 'TeamRoles',
  props: {
    rtype: String as PropType<'dps' | 'tank' | 'support'>,
    teamUuid: String,
    members: Array as PropType<{ uuid: string; name: string; primary: boolean; secondary: boolean }[]>,
  },
  components: { RoleIcon, PlayerCard },
  setup(props) {
    const store = useStore();
    const players = computed(() => store.state.players);

    const allowDrop = (ev: DragEvent) => {
      ev.preventDefault();
    };
    const drop = (ev: DragEvent, index: number) => {
      ev.preventDefault();
      const i = index - 1;
      const playerId = ev?.dataTransfer?.getData('playerTag');
      const teamUuid = ev?.dataTransfer?.getData('team');

      if (!playerId || !props.rtype || !props.teamUuid) return;

      const player = players.value[playerId];
      const role = PObj.getRole(player.stats.classes, props.rtype);

      if (!role.isActive) {
        return;
      }

      if (props.members && props.members[i]) {
        const member = props.members[i];
        if (member.uuid === playerId) {
          return;
        }

        if (!teamUuid) {
          store.commit(MutationTypes.REMOVE_FROM_TEAM, {
            teamUuid: props.teamUuid,
            playerId: member.uuid,
          });
          store.commit(MutationTypes.REMOVE_FROM_RESERVE, playerId);
          store.commit(MutationTypes.ADD_RESERVE, member.uuid);
          store.commit(MutationTypes.ADD_TEAMPLAYER, {
            teamUuid: props.teamUuid,
            playerId,
            role,
            roleName: props.rtype,
            playerName: player.identity.name,
            primary: role.primary,
            secondary: role.secondary,
          });
        } else {
          const teamF = store.state.teams.findIndex(team => team.uuid === teamUuid);
          const swapCandidate = store.state.players[member.uuid];

          if (teamF >= 0 && swapCandidate) {
            const memF = store.state.teams[teamF].members.find(
              lmember => lmember.uuid === playerId
            );

            if (!memF) return;

            const sdRole = PObj.getRole(swapCandidate.stats.classes, memF.role);

            if (sdRole.isActive) {
              store.commit(MutationTypes.REMOVE_FROM_TEAM, {
                teamUuid: props.teamUuid,
                playerId: member.uuid,
              });
              store.commit(MutationTypes.REMOVE_FROM_TEAM, {
                teamUuid,
                playerId,
              });
              store.commit(MutationTypes.ADD_TEAMPLAYER, {
                teamUuid: props.teamUuid,
                playerId,
                role,
                roleName: props.rtype,
                playerName: player.identity.name,
                primary: role.primary,
                secondary: role.secondary,
              });
              store.commit(MutationTypes.ADD_TEAMPLAYER, {
                teamUuid,
                playerId: member.uuid,
                role: sdRole,
                roleName: memF.role,
                playerName: member.name,
                primary: member.primary,
                secondary: member.secondary,
              });
            }
          }
        }
      } else if (teamUuid) {
        store.commit(MutationTypes.REMOVE_FROM_TEAM, {
          teamUuid,
          playerId,
        });
        store.commit(MutationTypes.REMOVE_FROM_RESERVE, playerId);
        store.commit(MutationTypes.ADD_TEAMPLAYER, {
          teamUuid: props.teamUuid,
          playerId,
          role,
          roleName: props.rtype,
          playerName: player.identity.name,
          primary: role.primary,
          secondary: role.secondary,
        });
      }
    };

    const showBalancerSR = computed(() => store.state.showBalancerSR);

    return { players, allowDrop, drop, showBalancerSR };
  },
});
